import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import React, {Component} from 'react';

import AddFilter from './AddFilter';
import * as ObjectConst from '../../constants/Property';
import {updateField} from '../../actions/CreatingObjectPage';

const propTypes = {
    isActive: PropTypes.bool.isRequired
};

const defaultProps = {
    updateField: (objectId, updateFieldCommand) => {
    }
};

class OtherSell extends Component {
    state = {
        VIEWS: '',
        KITCHEN: '',
        NEW_TYPE: '',
        CONDITION: '',
        RANGE_TYPE: '',
        ORIENTATION: '',
        EASE_FURNITURE: 'false'
    };

    componentWillReceiveProps(nextProps) {
        const {
            creatingObjectPage: {
                createdObject: {
                    id,
                    props: {
                        rangeType
                    },
                    other: {
                        views,
                        kitchen,
                        newType,
                        condition,
                        orientation
                    },
                    amenities
                }
            }
        } = nextProps;

        if (id !== undefined) {
            this.setState({
                VIEWS: views,
                KITCHEN: kitchen,
                NEW_TYPE: newType,
                CONDITION: condition,
                RANGE_TYPE: rangeType,
                ORIENTATION: orientation,
                EASE_FURNITURE: amenities.indexOf('FURNITURE') !== -1
            });
        }
    }

    updateField = event => {
        const {creatingObjectPage: {createdObject: {id}}} = this.props;
        const name = event.currentTarget.name;
        let value = event.currentTarget.value;

        if (name === ObjectConst.FIELDS.EASE_FURNITURE) {
            value = value === 'true';
        }

        const updateFieldCommand = {
            name: name,
            value: value
        };
        this.props.updateField(id, updateFieldCommand);
    };

    handleChange = event => {
        const newState = {};
        newState[event.currentTarget.name] = event.currentTarget.value;

        this.setState(newState);
    };

    render() {
        const {
            i18n,
            configuration: {
                object: {
                    viewsValues,
                    kitchenValues,
                    newTypeValues,
                    conditionValues,
                    orientationValues
                }
            }
        } = this.props;
        const {VIEWS, KITCHEN, NEW_TYPE, CONDITION, EASE_FURNITURE, ORIENTATION, RANGE_TYPE} = this.state;

        return (
            <div className={
                this.props.isActive ? 'clearfix tab_content animated show active' : 'clearfix tab_content animated show'
            }>
                <div className="heading">
                    <h3>
                        Другое
                    </h3>
                </div>

                <div className="clearfix mt30">
                    <div className="grid grid-width-1-3">
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>
                                        Помощь ...
                                    </span>
                                </span>
                                Ориентация:
                                <select
                                    value={ORIENTATION}
                                    onBlur={this.updateField}
                                    onChange={this.handleChange}
                                    name={ObjectConst.FIELDS.ORIENTATION}
                                >
                                    {orientationValues.map(elem => <option key={elem.value}
                                                                           value={elem.value}>{elem.title}</option>)}
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>
                                        Помощь ...
                                    </span>
                                </span>
                                Виды:
                                <select
                                    value={VIEWS}
                                    onBlur={this.updateField}
                                    onChange={this.handleChange}
                                    name={ObjectConst.FIELDS.VIEWS}
                                >
                                    {viewsValues.map(elem => <option key={elem.value}
                                                                     value={elem.value}>{elem.title}</option>)}
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>
                                        Помощь ...
                                    </span>
                                </span>
                                Состояние:
                                <select
                                    value={CONDITION}
                                    onBlur={this.updateField}
                                    onChange={this.handleChange}
                                    name={ObjectConst.FIELDS.CONDITION}
                                >
                                    {conditionValues.map(elem => <option key={elem.value}
                                                                         value={elem.value}>{elem.title}</option>)}
                                </select>
                            </label>
                        </div>
                    </div>

                    <div className="grid grid-width-1-3">
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>
                                        Помощь ...
                                    </span>
                                </span>
                                Мебель:
                                <select
                                    value={EASE_FURNITURE}
                                    onBlur={this.updateField}
                                    onChange={this.handleChange}
                                    name={ObjectConst.FIELDS.EASE_FURNITURE}
                                >
                                    <option value={false}>
                                        {i18n['creatingObjectPage.no']}
                                    </option>
                                    <option value={true}>
                                        {i18n['creatingObjectPage.yes']}
                                    </option>
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>
                                        Помощь ...
                                    </span>
                                </span>
                                Кухня:
                                <select
                                    value={KITCHEN}
                                    onBlur={this.updateField}
                                    onChange={this.handleChange}
                                    name={ObjectConst.FIELDS.KITCHEN}
                                >
                                    {kitchenValues.map(elem => <option key={elem.value}
                                                                       value={elem.value}>{elem.title}</option>)}
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                     <span>{i18n['creatingObjectPage.generalInformation.ourExclusive.hint']}</span>
                                </span>
                                {i18n['creatingObjectPage.generalInformation.ourExclusive']}
                                <select
                                    value={RANGE_TYPE}
                                    onBlur={this.updateField}
                                    onChange={this.handleChange}
                                    name={ObjectConst.FIELDS.RANGE_TYPE}
                                >
                                    <option value={ObjectConst.RANGE_TYPE.EXCLUSIVE}>
                                        {i18n['creatingObjectPage.yes']}
                                    </option>
                                    <option value={ObjectConst.RANGE_TYPE.OTHER}>
                                        {i18n['creatingObjectPage.no']}
                                    </option>
                                </select>
                            </label>
                        </div>
                    </div>

                    <div className="grid grid-width-1-3">
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>
                                        Помощь ...
                                    </span>
                                </span>
                                Новый:
                                <select
                                    value={NEW_TYPE}
                                    onBlur={this.updateField}
                                    onChange={this.handleChange}
                                    name={ObjectConst.FIELDS.NEW_TYPE}
                                >
                                    {newTypeValues.map(elem => <option key={elem.value}
                                                                       value={elem.value}>{elem.title}</option>)}
                                </select>
                            </label>
                        </div>
                    </div>

                    <AddFilter disabled={true}/>
                </div>
            </div>
        )
    }
}

OtherSell.propTypes = propTypes;
OtherSell.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    configuration: state.configuration,
    creatingObjectPage: state.creatingObjectPage
});

const mapDispatchToProps = {
    updateField
};

export default connect(mapStateToProps, mapDispatchToProps)(OtherSell);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/OtherSell.js